module.exports = __webpack_public_path__ + "static/media/441GriffinStNW_2018-06-05_35.63bd724f.jpg";